import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import LuxuryLevelWindowCleaning from "./sections/LuxuryLevelWindowCleaning";
import The6StarStandard from "./sections/The6StarStandard";
import OurPremiumServices from "./sections/OurPremiumServices";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import SecureYourFreeQuote from "./sections/SecureYourFreeQuote";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <LuxuryLevelWindowCleaning />
      <The6StarStandard />
      <OurPremiumServices />
      <ClientSuccessStories />
      <SecureYourFreeQuote />
      <Footer />
    </div>;
}